export const PACKAGES_PATH_PREFIX = '/packages';
/** Legacy slug-based path still supported */
export const PACKAGE_SLUG_PATH_PREFIX = '/package';

export const packagesPath = (...parts) => {
  const suffix = parts
    .filter(Boolean)
    .join('/')
    .replace(/^\/+/, '');
  return suffix ? `${PACKAGES_PATH_PREFIX}/${suffix}` : PACKAGES_PATH_PREFIX;
};

export const FETCH_PACKAGE_PAGE = 'app/Package/FETCH_PACKAGE_PAGE';
export const FETCH_PACKAGE_PAGE_SUCCESS =
  'app/Package/FETCH_PACKAGE_PAGE_SUCCESS';
export const FETCH_PACKAGE_PAGE_FAILURE =
  'app/Package/FETCH_PACKAGE_PAGE_FAILURE';

export const FETCH_PACKAGE_LOCATIONS = 'app/Package/FETCH_PACKAGE_LOCATIONS';
export const FETCH_PACKAGE_LOCATIONS_SUCCESS =
  'app/Package/FETCH_PACKAGE_LOCATIONS_SUCCESS';
export const FETCH_PACKAGE_LOCATIONS_FAILURE =
  'app/Package/FETCH_PACKAGE_LOCATIONS_FAILURE';

export const FETCH_PACKAGE_PAGE_BY_LOCATION =
  'app/Package/FETCH_PACKAGE_PAGE_BY_LOCATION';

export const SET_SELECTED_PACKAGE = 'app/Package/SET_SELECTED_PACKAGE';
export const SET_PACKAGE_QUANTITY = 'app/Package/SET_PACKAGE_QUANTITY';
export const SET_SELECTED_PACKAGE_LOCATION =
  'app/Package/SET_SELECTED_PACKAGE_LOCATION';

export const PURCHASE_PACKAGE = 'app/Package/PURCHASE_PACKAGE';
export const PURCHASE_PACKAGE_SUCCESS = 'app/Package/PURCHASE_PACKAGE_SUCCESS';
export const PURCHASE_PACKAGE_FAILURE = 'app/Package/PURCHASE_PACKAGE_FAILURE';

export const CLEAR_PACKAGE_PURCHASE_DATA =
  'app/Package/CLEAR_PACKAGE_PURCHASE_DATA';
export const CLEAR_PACKAGE_DATA = 'app/Package/CLEAR_PACKAGE_DATA';
